import React, { useState, useContext, useEffect } from "react";
import anime from "animejs";
import Sparkle from "../images/Sparkle.svg";
import TomoApp from "../images/landing/landingBanner/tomoboost_phone.webp";
import Portal from "../images/landing/landingBanner/portal.webp";
import earthBackground from "../images/landing/landingBanner/bg-earth.webp";
import Email from "../common/Email";
import { BreakpointContext } from "./common";
import NightSky from "./Boost/NightSky/NightSky";

const StarMark = ({ text }) => (
  <p className="my-3 flex items-center">
    <img src={Sparkle} alt="" className="inline px-3" style={{ width: 50, height: "auto" }}/>
    {text}
  </p>
);

const CheckMarks = ({ className }) => (
  <div
    className={`text-xl md:-ml-3 font-medium text-white whitespace-nowrap ${className}`}
  >
    <StarMark text="No Credit Checks. EVER." />
    <StarMark text="Learn. Build. Track." />
    <StarMark text="Manage Finances." />
  </div>
);

const Banner = () => {
  const [bounce, setBounce] = useState(false);
  const { isBelow } = useContext(BreakpointContext);
  // const { promoInfo } = useContext(PromoContext);

  // use md as the breakpoint between mobile view and desktop view
  const belowMd = isBelow("md");
  const bannerStyle = belowMd
    ? { height: "calc(100vh - 80px)", minHeight: 700 }
    : null;

  // animate phone coming out of portal on md screen
  useEffect(() => {
    anime({
      targets: ".landing-phone",
      translateY: "-170px",
      duration: 3000,
      easing: "easeInOutQuad",
      loop: false,
    });
  }, []);

  return (
    <div id="banner" className="relative flex flex-col" style={bannerStyle}>
      <img
        src={earthBackground}
        alt="earth from space"
        className="absolute bottom-0 left-0 right-0 mx-auto z-10"
      />
      {/* BACKGROUND NIGHT SKY ANIMATION */}
      <div className="w-full h-full absolute top-0 overflow-hidden">
        <NightSky />
      </div>
      <div className="flex flex-col items-center z-10">
        <div className="max-w-page justify-center mb-0 md:pb-5 lg:-mb-10 md:mt-3 flex items-center xl:flex-row lg:flex-row md:flex-row flex-col content-center">
          <div className="px-10 lg:pr-12 pb-8 flex flex-col items-center md:items-start">
            <div
              className={`flex flex-col items-center md:items-start text-primary font-bold ${
                belowMd ? "text-3xl" : "text-5xl"
              }`}
            >
              <div>Credit Building </div>
              <div>
                <span className="text-white">Starts Here</span>
                <span className="ml-1">.</span>
              </div>
            </div>
            <div
              className="relative mt-5 mx-auto text-center md:hidden"
              style={{ width: "33%", minWidth: 200 }}
            >
              <div
                className="w-full overflow-hidden relative z-50"
                style={{
                  paddingTop: "84%",
                  maskImage:
                    "linear-gradient(to bottom, #000 85%, transparent 100%)",
                  WebkitMaskImage:
                    "linear-gradient(to bottom, #000 85%, transparent 100%)",
                }}
              >
                <img
                  src={TomoApp}
                  alt="tomo"
                  className="landing-phone w-full absolute left-0"
                  style={{
                    maskImage:
                      "linear-gradient(to bottom, black 48%, transparent 54%)",
                    WebkitMaskImage:
                      "linear-gradient(to bottom, black 48%, transparent 54%)",
                  }}
                />
              </div>
              <img
                src={Portal}
                alt=""
                className="absolute z-0"
                style={{
                  marginTop: "-14%",
                  transform: "scale(1.5)",
                }}
              />
            </div>
            <CheckMarks className="mt-10 md:mt-5" />
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <div
              className="mt-5 flex flex-col lg:flex-row gap-x-4 gap-y-10"
              onClick={() => setBounce(!bounce)}
            >
              <Email bounce={bounce} text="Get Started" />
            </div>
          </div>
          <div
            className="hidden text-center lg:mx-10 sm:pb-20 md:block"
            style={{ width: "33%", minWidth: 350, maxWidth: 400 }}
          >
            <img src={TomoApp} alt="tomo" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
